import { useEffect } from 'react';
import { useTotalUnreadCount } from './queries/useMessaging';
import { usePageTitleStore } from '../store/usePageTitleStore';
import {
  DEFAULT_DOCUMENT_TITLE,
  formatUnreadDocumentTitle,
  pageDocumentTitle,
} from '../lib/unreadDocumentTitle';

/** Titre de l'onglet : nom de la page (un dossier, par exemple) et compteur de messages, `(3) Divorce Durand · CIME Avocats`. */
export function useUnreadDocumentTitle() {
  const unread = useTotalUnreadCount();
  const pageTitle = usePageTitleStore((s) => s.pageTitle);

  useEffect(() => {
    document.title = formatUnreadDocumentTitle(unread, pageDocumentTitle(pageTitle));
    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, [unread, pageTitle]);
}
